<template>
  <div class="crud">
    <DataTable :value="entities" selectionMode="single" :selection.sync="newQuotation" @row-select="onRowSelect"
               dataKey="_id" :paginator="true" :rows="15">
      <Column field="title" :header="$t('crud.quotation.labels.title')"></Column>
      <Column field="description" :header="$t('crud.quotation.labels.description')"></Column>
      <Column field="tjm" :header="$t('crud.quotation.labels.tjm')"></Column>
      <Column field="company" :header="$t('crud.quotation.labels.company')"></Column>
      <Column field="duration" :header="$t('crud.quotation.labels.duration')"></Column>
      <Column field="discount" :header="$t('crud.quotation.labels.discount')"></Column>
      <Column field="tasks" :header="$t('crud.quotation.labels.tasks')">
        <template #body="slotProps">
          <div v-for="task in slotProps.data.tasks" :key="task.id">{{ task.summary }}</div>
        </template>
      </Column>
      <Column field="amount" :header="$t('crud.quotation.labels.amount')"></Column>
      <template #footer>
        <Button :label="$t('shared.actions.create')" icon="pi pi-plus" @click="createQuotation" class="p-button-primary" />
      </template>
    </DataTable>

    <Dialog :visible.sync="dialogVisible" :style="{width: '400px'}" :modal="true">
      <template #header>
        <span>{{ $t('crud.quotation.modals.titles.' + action) }}</span>
      </template>
      <div>
        <label for="title">{{ $t('crud.quotation.labels.title') }}</label>
        <input id="title" v-model="newQuotation.title" name="title" type="text">
      </div>
      <div>
        <label for="description">{{ $t('crud.quotation.labels.description') }}</label>
        <input id="description" v-model="newQuotation.description" name="description" type="text">
      </div>
      <div>
        <label for="tjm">{{ $t('crud.quotation.labels.tjm') }}</label>
        <input id="tjm" v-model="newQuotation.tjm" name="tjm" type="number">
      </div>
      <div>
        <label for="company">{{ $t('crud.quotation.labels.company') }}</label>
        <input id="company" v-model="newQuotation.company" name="company" type="text">
      </div>
      <div>
        <label for="duration">{{ $t('crud.quotation.labels.duration') }}</label>
        <input id="duration" v-model="newQuotation.duration" name="duration" type="number">
      </div>
      <div>
        <label for="discount">{{ $t('crud.quotation.labels.discount') }}</label>
        <input id="discount" v-model="newQuotation.discount" name="discount" type="number">
      </div>
      <div>
        <label for="tasks">{{ $t('crud.quotation.labels.tasks') }}</label>
        <MultiSelect id="tasks" v-model="newQuotation.tasks" :options="tasks" optionLabel="summary" placeholder="Select a task" />
      </div>
      <div>
        <label for="amount">{{ $t('crud.quotation.labels.amount') }}</label>
        <input id="amount" v-model="newQuotation.amount" name="amount" type="number">
      </div>
      <template #footer>
        <Button v-if="action === 'update'" :label="$t('shared.actions.delete')" icon="pi pi-trash" @click="deleteQuotation" class="p-button-danger"></Button>
        <Button :label="$t('shared.actions.save')" icon="pi pi-check" @click="saveQuotation" class="p-button-success"></Button>
        <Button :label="$t('shared.actions.cancel')" icon="pi pi-times" @click="cancelEdit" class="p-button-secondary"></Button>
      </template>
    </Dialog>
  </div>
</template>

<script>
  import MultiSelect from 'primevue/multiselect';
  import DataTable from 'primevue/datatable';
  import Column from 'primevue/column';
  import Dialog from "primevue/components/dialog/Dialog";
  import Button from 'primevue/button';
  import Quotation from '../../models/quotation.model';

  export default {
    name: 'Quotations',
    components: {
      Dialog,
      DataTable,
      Column,
      MultiSelect,
      Button
    },
    props: {},
    data: () => {
      return {
        newQuotation: {},
        dialogVisible: false,
        action: '',
        taskSelected: null,
        entityName: ''
      }
    },
    computed: {
      tasks() {
        return this.$store.state.tasks;
      },
      entities() {
        return this.$store.state.quotations;
      }
    },
    methods: {
      onRowSelect: function(event) {
        this.action = 'update';
        this.newQuotation = {...event.data};
        this.dialogVisible = true;
      },
      createQuotation: function() {
        this.action = 'create';
        this.resetNewQuotation();
        this.dialogVisible = true;
      },
      deleteQuotation: function() {
        this.$store.dispatch('removeQuotation', this.newQuotation).then((succeed) => {
          if (succeed) {
            this.$toast.add({severity: 'success', summary: this.$t('crud.quotation.toasts_msg.summary.delete'),
                             detail: this.$t('crud.quotation.toasts_msg.success.delete'), life: 3000});
            this.dialogVisible = false;
            this.resetNewQuotation();
          } else {
            this.$toast.add({severity: 'error', summary: this.$t('crud.quotation.toasts_msg.summary.delete'),
                             detail: this.$t('crud.quotation.toasts_msg.fail.delete'), life: 3000});
          }
        });
      },
      saveQuotation: function () {
        if (
          this.$isNotEmpty(this.newQuotation.title)
          && this.$isNotEmpty(this.newQuotation.description)
          && this.$isNotEmpty(this.newQuotation.tjm) && !isNaN(this.newQuotation.tjm)
          && this.$isNotEmpty(this.newQuotation.company)
          && this.$isNotEmpty(this.newQuotation.duration) && !isNaN(this.newQuotation.duration)
          && this.$isNotEmpty(this.newQuotation.discount) && !isNaN(this.newQuotation.discount)
          && this.$isNotEmpty(this.newQuotation.tasks)
          && this.$isNotEmpty(this.newQuotation.amount) && !isNaN(this.newQuotation.amount)
        ) {
          let dispatch = 'postQuotation';
          if (this.action === 'update') {
            dispatch = 'updateQuotation';
          }

          this.$store.dispatch(dispatch, this.newQuotation).then((succeed) => {
            if (succeed) {
              this.$toast.add({severity: 'success', summary: this.$t('crud.quotation.toasts_msg.summary.save'),
                               detail: this.$t('crud.quotation.toasts_msg.success.save'), life: 3000});
              this.dialogVisible = false;
              this.resetNewQuotation();
            } else {
              this.$toast.add({severity: 'error', summary: this.$t('crud.quotation.toasts_msg.summary.save'),
                               detail: this.$t('crud.quotation.toasts_msg.fail.save'), life: 3000});
            }
          });
        } else {
          this.$toast.add({severity: 'error', summary: this.$t('crud.quotation.toasts_msg.summary.validation'),
                           detail: this.$t('crud.quotation.toasts_msg.validation.fieldsMissing'), life: 3000
          });
        }
      },
      resetNewQuotation: function () {
        this.newQuotation = new Quotation({});
      },
      cancelEdit: function () {
        this.dialogVisible = false;
        this.newQuotation = new Quotation({});
      }
    },
    created: function () {
      this.$store.dispatch('fetchAll');
      this.resetNewQuotation();
      this.entityName = this.$t('crud.quotation.quotation')
    },
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .crud {
  }
</style>
